// DE,US => e.g. 12345
// CA => e.g. A1A 1A1
export const zipcodePatternConfig: { [locale: string]: string } = {
  de_DE: '[0-9]{5}',
  en_US: '[0-9]{5}',
  en_CA: '[A-Za-z]\\d[A-Za-z] ?\\d[A-Za-z]\\d',
  fr_CA: '[A-Za-z]\\d[A-Za-z] ?\\d[A-Za-z]\\d',
};
